import TrashCan from '../src/TrashCan';
export default TrashCan;
